import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { featureName } from './loading.state';
import { loadingReducer } from './loading.reducer';

@NgModule({
  imports: [StoreModule.forFeature(featureName, loadingReducer)],
})
export class LoadingStoreModule {}
